import { useInputMultiSelectContext } from '../../input-multi-select'
import type {
  InputMultiSelectLabelProps,
  InputMultiSelectScopedProps,
} from '../../input-multi-select.types'
import { InputMultiSelectLabelVariants } from './index.styles'

export const InputMultiSelectLabel = (
  props: InputMultiSelectScopedProps<InputMultiSelectLabelProps>
) => {
  const { __scopeInputMultiSelect, children, ...rest } = props

  const { disabled, size } = useInputMultiSelectContext(
    'InputMultiSelectLabel',
    __scopeInputMultiSelect
  )

  if (!children) return null

  return (
    <div className="flex h-extrasmall w-full items-center rounded-none border-none px-onepulse text-left">
      <label
        {...rest}
        className={InputMultiSelectLabelVariants({ disabled, size })}
        aria-disabled={disabled}
      >
        {children}
      </label>
    </div>
  )
}
